import {useCallback, useEffect, useState} from 'react';
import {useSelector, useStore} from 'react-redux';
import {useCrowdfundCopy} from '~/common/fabric/CreateDesign/pledge_copy';
import {UPDATE_PLEDGELING_OPTIONS} from '~/common/fabric/reducers/giftingOptions/constants';
import {DonationsModule} from '~/ViewInvitation/routes/Landing/DonationModule/DonationsModule';
import {HeartCheckIcon} from '~library/svg/HeartCheckIcon';
import {OptionWrapper} from './OptionWrapper';

export const Crowdfunding = ({
  setShowOverlay,
  shouldShowUpsellModal,
  toggleUpsellModal,
  setToToggleOff,
}) => {
  const store = useStore();
  const {eviteEvent, giftingOptions} = store.getState();
  const eventType = useSelector(({fabricTemplate}) => fabricTemplate?.eventType);
  const crowdfundCopy = useCrowdfundCopy(eventType);

  const onEdit = useCallback(async () => {
    setShowOverlay('crowd-funding');
  }, [setShowOverlay]);

  const removeAction = useCallback(() => {
    store.dispatch({
      type: UPDATE_PLEDGELING_OPTIONS,
      // biome-ignore lint/style/useNamingConvention: existing error
      payload: {beneficiary_type: 'Crowdfund'},
    });
  }, [store]);

  const onRemove = useCallback(async () => {
    if (shouldShowUpsellModal()) {
      setToToggleOff('crowdFunding');
      toggleUpsellModal();
    } else {
      removeAction();
    }
  }, [removeAction, setToToggleOff, shouldShowUpsellModal, toggleUpsellModal]);

  const [donations, setDonations] = useState([]);
  useEffect(() => {
    if ('pledgeling_beneficiary_type' in giftingOptions.pledgeling_data.Crowdfund) {
      setDonations([
        {
          id: `${eviteEvent.id}_Crowdfund`,
          // biome-ignore lint/style/useNamingConvention: existing error
          donation_url: `https://${window.pledge_url}/widgets/donate/${window.pledge_key}/${eviteEvent.id}_Crowdfund`,
          found: true,
        },
      ]);
    } else {
      setDonations([]);
    }
  }, [eviteEvent.id, giftingOptions]);

  return (
    <OptionWrapper
      icon={<HeartCheckIcon />}
      title={crowdfundCopy.header}
      subtitle={crowdfundCopy.subHeader}
      onEdit={onEdit}
      isActive={donations.length > 0}
      onRemove={onRemove}
    >
      <DonationsModule donations={donations} readonly isCreationFlow />
    </OptionWrapper>
  );
};
